import { t } from "@/i18n-js/instance";
import { PRICE_SCENARIOS } from "@circle-react/helpers/paywallPriceHelpers";
import type { PaywallCheckoutPreview } from "@circle-react/types";
import { Lines } from "../Lines";
import type { ComponentLineProps } from "../types";

const buildOptions = (preview: PaywallCheckoutPreview) => {
  if (
    [
      PRICE_SCENARIOS.upfrontThenTrialThenValue,
      PRICE_SCENARIOS.upfrontThenValue,
    ].includes(preview.preview_scenario)
  ) {
    return {
      label: t("paywall_checkout.amount_due_intro_fee"),
    };
  }

  if (
    [
      PRICE_SCENARIOS.trialThenValue,
      PRICE_SCENARIOS.trialThenUpfrontThenValue,
    ].includes(preview.preview_scenario)
  ) {
    return { hide: true };
  }

  return {};
};

export const TotalDueTodayLine = ({ preview }: ComponentLineProps) => {
  const options = buildOptions(preview);

  return <Lines.TotalDueTodayLine preview={preview} options={options} />;
};
